<template>
<div class="chapter">
<div class="inner_page">
<p class="C635"><strong><span id="id_231">CONTENTS </span></strong></p>
<p class="cont1"><a href="#/html/04_Acknowle">ACKNOWLEDGMENT</a></p>
<p class="cont2"><a href="#/html/01_Introduc">Introduction: Backstory: Breaking Omertà</a></p>
<p class="cont2"><a href="#/html/02_Chapter#page_7">1. Game Changer: The Role of <em>The Sopranos </em>in the Resurgence of HBO</a></p>
<p class="cont"><span href="#/html/03_Chapter#page_23" title="Link target outside of Sample">2. Cinematic Television: The Education of David Chase</span></p>
<p class="cont"><span href="#/html/04_Chapter" title="Link target outside of Sample">3. Disorganized Crime: Living Large in the Suburbs</span></p>
<p class="cont"><span href="#/html/05_Chapter" title="Link target outside of Sample">4. Situation Tragedy: A Midlife Crisis for the Gangster Genre</span></p>
<p class="cont2"><span href="#/html/06_Conclusi" title="Link target outside of Sample">Conclusion: Strategic Ambiguity: <em>The Sopranos</em>’ Aftereffect</span></p>
<p class="cont"><span href="#/html/07_Works_Ci" title="Link target outside of Sample">WORKS CITED</span></p>
<p class="cont"><span href="#/html/08_Subject" title="Link target outside of Sample">SUBJECT INDEX</span></p>
<p class="cont"><span href="#/html/09_Televisi" title="Link target outside of Sample">TELEVISION SERIES INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Content.vue?b1387fe2